import { useState } from "react";
import { Image, ImageProps, Paper, PaperProps, Radio, useMantineTheme } from "@mantine/core";
import { File } from "src/graphql/generated/graphql";

export interface SelectableImageProps extends ImageProps {
    file: File;
    isSelected?: boolean;
    containerProps?: PaperProps;
    onSelect?();
}

export const SelectableImage = ({ file, isSelected, containerProps, onSelect, ...rest }: SelectableImageProps) => {
    const theme = useMantineTheme();

    const [isHovered, setIsHovered] = useState(false);

    return (
        <Paper
            {...containerProps}
            component="label"
            pos="relative"
            radius="md"
            htmlFor={`checkbox_${file?.id}`}
            shadow={isHovered ? "md" : "xs"}
            style={{
                overflow: "hidden",
                cursor: "pointer",
                borderColor: isHovered || isSelected ? theme.colors.orange[6] : undefined,
            }}
            onMouseOver={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            withBorder
        >
            <Image {...rest} src={file?.src} />
            <Radio
                pos="absolute"
                color="orange"
                size="md"
                id={`checkbox_${file?.id}`}
                name={`checkbox_${file?.id}`}
                style={{
                    top: "12px",
                    right: "12px",
                }}
                checked={isSelected}
                onChange={() => onSelect?.()}
            />
        </Paper>
    );
};
